export default {
  name: 'launcher',
  computed: {
    breadcrumbs () {
      return this.$route.meta.breadcrumbs
    }
  },
  data () {
    return {
      systemTitle: 'BRIQUE FDC'
    }
  }
}
